import { render, staticRenderFns } from "./ClimateEnvironment.vue?vue&type=template&id=2dae603b&"
import script from "./ClimateEnvironment.vue?vue&type=script&lang=js&"
export * from "./ClimateEnvironment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports